import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import useSettingsParams from "hooks/useSettingsParams";
import { useObject } from "./context/ObjectProvider";
import ObjectsFilter from "./ObjectsToolBar/ObjectsFilter";
import ListToolBarActions from "components/toolbar/ListToolBarActions";
import EToolTip from "components/others/EToolTip";
import { useAuth } from "context/AuthContext";
import { canViewSales, hasUserAccess } from "utils/helpers/access/hasUserAccess";
import { useNeedPay } from 'modules/admin';
import SolarIcon from 'components/icons/SolarIcon';

const ObjectsToolBar = ({ setNewObject, setNewSale }) => {
    const { t } = useTranslation(['Objects']);
    const params = useSettingsParams();
    const { auth } = useAuth();
    const { needPay } = useNeedPay();
    const {
        onlySale,
        triggerListReset,
        triggerListRefresh,
        showDebtor,
        setShowDebtor,
        showClient,
        setShowClient,
    } = useObject();
    const canCreateObject = hasUserAccess(auth?.user, 'objectCreate');
    const canCreateSale = canViewSales(auth?.user);

    return (
        <div className="mb-3" style={{minWidth:'100px'}}>
            <div className="page-toolbar-actions">

            {onlySale && canCreateSale && (
                <Button
                    className="fs-14 ms-1"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setNewSale({});
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddSale')}</span>
                </Button>
            )}

            {!onlySale && canCreateObject && (
                <Button
                    className="fs-14 ms-1"
                    size="sm"
                    variant="success"
                    onClick={(e) => {
                        e.currentTarget.blur();
                        if (needPay()) return;
                        setNewObject({});
                    }}
                >
                    <SolarIcon name="plus" className="fs-14 p-0" />
                    <span className="ms-1">{t('toolAddObject')}</span>
                </Button>
            )}

            <EToolTip title={showClient ? t('toolHideClient') : t('toolShowClient')}>
                <span className="d-inline-block ms-1">
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        variant={showClient ? 'info' : 'secondary'}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            setShowClient((prev) => !prev);
                        }}
                    >
                        <SolarIcon name="person-vcard" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>

            {params.objectPaymentControl && (
            <EToolTip title={showDebtor ? t('toolHideDebtor') : t('toolShowDebtor')}>
                <span className="d-inline-block ms-1">
                    <Button
                        className="fs-14 px-2 toolbar-icon-btn"
                        size="sm"
                        variant={showDebtor ? 'info' : 'secondary'}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            setShowDebtor((prev) => !prev);
                        }}
                    >
                        <SolarIcon name="cash-coin" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>
            )}

            <ListToolBarActions onReset={triggerListReset} onRefresh={triggerListRefresh} />

            <ObjectsFilter />

        </div>
    </div>

    )
}

export default ObjectsToolBar;
